import * as Sentry from '@sentry/react';

export const sentryCaptureException = (e, context) => {
  // eslint-disable-next-line
  console.error('ERROR:', e);
  Sentry.captureException(e, context || e?.context);
};
